const t=()=>Intl.DateTimeFormat().resolvedOptions();export{t as getUserDateTimeOptions};
